/* src/app/app.component.css */
header {
  height: 64px;
  position: sticky;
  top: 0;
  z-index: 999;
}
nav {
  height: 64px;
}
.sidenav-trigger {
  height: 64px !important;
  line-height: 64px !important;
}
.inline-block {
  display: inline-block !important;
}
.nav-wrapper > ul > li > a {
  display: block;
}
.veil {
  background: rgba(255, 255, 255, 0.8);
  color: #444;
}
.veil > .nav-wrapper a,
.veil .footer-copyright {
  color: #444;
}
#submenu {
  width: auto !important;
}
.dropdown-content {
  top: 64px !important;
}
.contactbrands .icon {
  width: 22px;
  height: 22px;
  margin: 5px;
}
.paymentbrands .icon {
  margin-top: 5px;
  margin-bottom: 5px;
  margin-right: 5px;
}
.icon.facebook-messenger {
  fill: url(#myGradient);
}
.user-view {
  background-image: url("./media/office.jpg");
}
.trustpilot-widget {
  margin: 1rem 0 1rem -42px;
}
/*# sourceMappingURL=app.component.css.map */
